<script setup lang="ts">
import Icon from "@/components/Core/Icon.vue";
import { FEEDBACK_COPY } from "@/copy/feedback";

defineProps({
  followUp: { type: Boolean, default: false },
  failed: { type: Boolean, default: false },
});
const emit = defineEmits({ retry: () => true, close: () => true });
</script>

<template>
  <div role="status" class="flex min-h-12 items-center gap-2.5 py-1 pr-2 pl-4">
    <Icon
      v-if="failed"
      name="exclamation-circle"
      class="size-4 shrink-0 text-red-700"
      aria-hidden="true"
    />
    <Icon
      v-else
      name="heart-solid"
      class="size-4 shrink-0 overflow-visible text-purple-700 motion-safe:transition motion-safe:delay-150 motion-safe:duration-300 motion-safe:ease-[cubic-bezier(0.34,1.56,0.64,1)] starting:scale-50 starting:opacity-0"
      aria-hidden="true"
    />
    <p class="min-w-0 flex-1 text-sm font-semibold text-gray-900">
      <template v-if="failed">{{ FEEDBACK_COPY.sendFailed }}</template>
      <template v-else-if="followUp">{{
        FEEDBACK_COPY.thanksFollowUp
      }}</template>
      <template v-else>{{ FEEDBACK_COPY.thanks }}</template>
    </p>
    <button
      v-if="failed"
      type="button"
      class="btn-basic btn-sm shrink-0"
      @click="emit('retry')"
    >
      {{ FEEDBACK_COPY.retry }}
    </button>
    <button
      type="button"
      :aria-label="FEEDBACK_COPY.close"
      class="shrink-0 rounded-md p-2 text-gray-600 hover:bg-gray-100 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet-700"
      @click="emit('close')"
    >
      <Icon name="times" class="size-4" aria-hidden="true" />
    </button>
  </div>
</template>
